<om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
<nz-select
  class="w-full"
  [class]="class"
  [nzDisabled]="disabled"
  [formControl]="control"
  [nzMode]="mode"
  [nzAllowClear]="clear"
  [nzPlaceHolder]="placeholder"
  [compareWith]="compare"
  [nzShowSearch]="showSearch"
  [nzFilterOption]="customFilter"
  [nzServerSearch]="serverSearch"
  (nzOnSearch)="onSearchInput($event)"
  (nzOpenChange)="onOpenChange($event)"
  (nzScrollToBottom)="scrollToBottom.emit()"
>
  <!-- trackBy: an unstable [options] reference must not recreate the option nodes on every
       change-detection tick — a click on a node recreated mid-gesture never lands -->
  <nz-option nzCustomContent *ngFor="let item of options; trackBy: trackByValue" [nzValue]="item[valueName]" [nzLabel]="item[labelName]" [nzDisabled]="item['disabled']">
    <div class="flex items-center gap-2">
      <ng-container *ngIf="item['icon']">
        <span
          nz-icon
          [nzType]="item['icon']"
          [ngStyle]="{ color: item['disabled'] ? '#a1110e' : '#008753' }"
          [nzTheme]="item['iconColor'] ? 'twotone' : ''"
          [nzTwotoneColor]="item['iconColor'] ? item['iconColor'] : ''"
        ></span>
      </ng-container>
      <div class="flex flex-col">
        <span>{{ item[labelName] }}</span>
        <small *ngIf="subLabelName && item[subLabelName]" class="text-gray-500">{{ item[subLabelName] }}</small>
      </div>
    </div>
  </nz-option>
</nz-select>
<div *ngIf="!hideValidators" class="om-error-placeholder">
  <om-error [control]="control"></om-error>
</div>
